/* PDP desktop: keep the complete media gallery visible while product details scroll. */
(function () {
  if (window.JHPdpMediaSticky) return;
  window.JHPdpMediaSticky = true;

  var desktop = window.matchMedia('(min-width: 990px)');
  var pdp;
  var gallery;
  var info;
  var mediaSticky;
  var resizeObserver;
  var frame = 0;

  function addStyles() {
    if (document.getElementById('jh-pdp-media-sticky-style')) return;

    var style = document.createElement('style');
    style.id = 'jh-pdp-media-sticky-style';
    style.textContent =
      '@media screen and (min-width:990px){' +
        '.pdp{align-items:stretch!important;}' +
        '.pdp>.gallery{position:relative!important;align-self:stretch!important;min-height:0!important;}' +
        '.pdp>.info{position:relative!important;top:auto!important;align-self:start!important;}' +
        '.pdp>.info::after{content:none!important;display:none!important;height:0!important;}' +
        '.pdp>.gallery>.jh-media-sticky{position:sticky!important;top:var(--jh-pdp-media-top,110px)!important;width:100%!important;z-index:3!important;}' +
        '.pdp>.gallery>.jh-media-sticky>.main{position:relative!important;top:auto!important;left:auto!important;width:auto!important;bottom:auto!important;z-index:auto!important;}' +
        '.pdp>.gallery>.jh-media-sticky>.thumbs{display:flex!important;visibility:visible!important;opacity:1!important;}' +
        '.pdp>.gallery>.gallery-related{display:none!important;}' +
        '.pdp~section.related{display:block!important;width:100%!important;max-width:100%!important;overflow:hidden!important;}' +
      '}';
    document.head.appendChild(style);
  }

  function ensureStructure() {
    pdp = document.querySelector('.pdp');
    gallery = pdp && pdp.querySelector(':scope > .gallery');
    info = pdp && pdp.querySelector(':scope > .info');
    if (!pdp || !gallery || !info) return false;

    mediaSticky = gallery.querySelector(':scope > .jh-media-sticky');

    if (!mediaSticky) {
      var legacyLock = gallery.querySelector(':scope > .jh-media-lock');
      if (legacyLock) {
        legacyLock.className = 'jh-media-sticky';
        mediaSticky = legacyLock;
      }
    }

    if (!mediaSticky) {
      var main = gallery.querySelector(':scope > .main');
      var thumbs = gallery.querySelector(':scope > .thumbs');
      if (!main) return false;

      mediaSticky = document.createElement('div');
      mediaSticky.className = 'jh-media-sticky';
      gallery.insertBefore(mediaSticky, main);
      mediaSticky.appendChild(main);
      if (thumbs) mediaSticky.appendChild(thumbs);
    } else {
      var looseThumbs = gallery.querySelector(':scope > .thumbs');
      if (looseThumbs) mediaSticky.appendChild(looseThumbs);
    }

    var legacyPlaceholder = gallery.querySelector(':scope > .jh-media-placeholder');
    if (legacyPlaceholder) legacyPlaceholder.remove();

    return true;
  }

  function updateStickyTop() {
    frame = 0;
    if (!ensureStructure()) return;
    addStyles();

    if (!desktop.matches) {
      mediaSticky.style.removeProperty('--jh-pdp-media-top');
      return;
    }

    var mediaHeight = mediaSticky.offsetHeight;
    var headerClearance = 110;
    var bottomClearance = 6;
    var stickyTop = Math.min(
      headerClearance,
      window.innerHeight - mediaHeight - bottomClearance
    );

    mediaSticky.style.setProperty('--jh-pdp-media-top', Math.round(stickyTop) + 'px');
  }

  function queueUpdate() {
    if (frame) return;
    frame = requestAnimationFrame(updateStickyTop);
  }

  function observe() {
    if (!window.ResizeObserver || !mediaSticky) return;
    if (resizeObserver) resizeObserver.disconnect();

    resizeObserver = new ResizeObserver(queueUpdate);
    resizeObserver.observe(mediaSticky);
    resizeObserver.observe(info);
  }

  function init() {
    if (!ensureStructure()) return;
    addStyles();
    observe();
    queueUpdate();

    mediaSticky.querySelectorAll('img, video').forEach(function (media) {
      if (media.tagName === 'IMG' && media.complete) return;
      media.addEventListener('load', queueUpdate, { once: true });
      media.addEventListener('loadedmetadata', queueUpdate, { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', queueUpdate);
  document.addEventListener('shopify:section:load', init);

  if (desktop.addEventListener) {
    desktop.addEventListener('change', queueUpdate);
  }
})();
